export default {
    parent: 'EvaluationLayout',
    url: '/evaluation',
    template: '<ui-view></ui-view>',
    abstract: true,
    resolve: {
        bootstrap (TranslationService) {
            return TranslationService.changeLanguage();
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/evaluation/index.js